import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { AGGREGATED_DIFF_START_FINISH_LEGEND_AUGUST } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';

// Выбор года вынесен на таймлайн внизу карты
// (AggDiffStartsFinishesAugustYearTimeline). Здесь остаётся заголовок и легенда.
const AggDiffStartsFinishesFilterComponent = () => (
    <div>
        <div className={styles.legHead}>
            {t`Агрегированая разница стартов и финишей (август), %`}:
        </div>
        <LegendRenderer config={AGGREGATED_DIFF_START_FINISH_LEGEND_AUGUST} />
    </div>
);

export const AggregatedDiffStartFinishLegendAugust = withDisplayedLayersCheck(
    AggDiffStartsFinishesFilterComponent,
    t`Агрегированая разница стартов и финишей (август)`
);
